import { Crown, ThumbsUp, AlertTriangle, Siren, Power, CircleDashed } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/group-oversight`;

export const RATING_META = {
  outstanding:        { label: 'Outstanding',               short: 'Outstanding',  hex: '#10B981', Icon: Crown,         score: 4 },
  good:               { label: 'Good',                      short: 'Good',         hex: '#38BDF8', Icon: ThumbsUp,      score: 3 },
  needs_improvement:  { label: 'Needs Improvement',         short: 'Needs Impr.',  hex: '#F59E0B', Icon: AlertTriangle, score: 2 },
  urgent_improvement: { label: 'Urgent Improvement Needed', short: 'Urgent',       hex: '#F43F5E', Icon: Siren,         score: 1 },
  shutdown:           { label: 'Shutdown',                  short: 'Shutdown',     hex: '#64748B', Icon: Power,         score: 0 },
};
export const UNRATED = { label: 'Not yet inspected', short: 'Unrated', hex: '#94A3B8', Icon: CircleDashed };
export const ratingMeta = (r) => RATING_META[r] || UNRATED;

export const CATEGORY_LABELS = {
  leadership: 'Leadership', staff_conduct: 'Staff conduct', activity: 'Activity & events',
  member_experience: 'Member experience', compliance: 'Compliance & safety',
};

export const GROUP_TYPES = ['Food & Beverage', 'Hospitality', 'Retail', 'Education', 'Café', 'Entertainment', 'Transport', 'Emergency Services', 'Other'];

export const imgUrl = (p) => {
  if (!p) return null;
  if (p.startsWith('http')) return p;
  return `${BACKEND_URL}${p.startsWith('/api') ? '' : '/api'}${p.startsWith('/') ? '' : '/'}${p}`;
};

export const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const daysUntil = (d) => d ? Math.ceil((new Date(d.slice(0, 10)) - new Date(new Date().toISOString().slice(0, 10))) / 86400000) : null;

export const inputCls = 'w-full px-3 py-2.5 bg-black/40 border border-white/[0.08] rounded-xl text-white text-sm placeholder-white/25 focus:outline-none focus:border-cyan-400/40';
export const labelCls = 'block text-[9px] tracking-[0.18em] uppercase text-white/45 font-semibold mb-1.5';
